import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("path", {
              fill: "currentColor",
              d: "M2.833 7.125c.189-.251.53-.32.797-.175l.078.05 6.167 4.625c.06.044.136.053.203.027l.047-.027L16.292 7c.276-.207.668-.151.875.125.188.251.159.598-.055.814l-.07.061-6.167 4.625c-.481.361-1.13.387-1.636.077l-.114-.077L2.958 8c-.276-.207-.332-.599-.125-.875z",
              transform: "translate(-1254 -2455) translate(1248 2449) translate(6 6) rotate(90 10 9.896)"
            })
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }